import React from "react";
import { useSettings } from "../../../contexts/use-settings";
import { Box, Typography, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const SwitchContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '44px',
  height: '22px',
  backgroundColor: theme.palette.mode === 'dark' ? '#39393D' : '#E9E9EA',
  borderRadius: '11px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  padding: '2px',
}));

const SwitchThumb = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLight',
})(({ theme, isLight }) => ({
  width: '18px',
  height: '18px',
  backgroundColor: '#fff',
  borderRadius: '50%',
  position: 'absolute',
  top: '2px',
  left: isLight ? '24px' : '2px',
  transition: 'left 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  '&:before': {
    content: '""',
    width: '12px',
    height: '12px',
    backgroundImage: isLight 
      ? `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 20 20"><path fill="${encodeURIComponent(theme.palette.primary.main)}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`
      : `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 20 20"><path fill="${encodeURIComponent('#fff')}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
}));

const ThemeSwitches = ({ noText = false }) => {
  const { settings, saveSettings } = useSettings();
  const isLight = settings.theme === 'light';

  const handleToggle = () => {
    const newTheme = isLight ? 'dark' : 'light';
    saveSettings({
      ...settings,
      theme: newTheme,
    });
  };

  return (
    <Stack direction="row" alignItems="center" spacing={noText ? 0 : 1}>
      {!noText && (
        <Typography
          variant="body2"
          sx={{
            fontSize: '12px',
            color: (theme) => theme.palette.neutral[600],
          }}
        >
          Dark
        </Typography>
      )}
      <SwitchContainer onClick={handleToggle}>
        <SwitchThumb isLight={isLight} />
      </SwitchContainer>
      {!noText && (
        <Typography
          variant="body2"
          sx={{
            fontSize: '12px',
            color: (theme) => theme.palette.neutral[600],
          }}
        >
          Light
        </Typography>
      )}
    </Stack>
  );
};

export default ThemeSwitches;
